<template>
  <div class="pull-height animated">
		<div class="index" >
			<sidebar class="left"></sidebar>
      <div class="right">
        <div class="main" ref="ciicMainBox">
          <div class="router" id="main" ref="ciicMain" v-if="accessToken">
            <keep-alive>
              <router-view @toTop="scrolltop"  v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
            </keep-alive>
            <router-view @toTop="scrolltop"  v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
          </div>
        </div>
      </div>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import sidebar from './sidebar';
import hrCommon from "@/api/common/hrcloudCommon";
import {base64Encode} from "@/util/endecode";
import {encrypt} from "@/util/util";
import store from "@/store";
import {switchCus} from "@/api/user/login";
export default {
  components: {
    sidebar,
  },
  name: 'index',
  data() {
    return {
      isRouterAlive: true,
      dicts: {},
      flag: this.$route.query.flag,
      cusId: this.$route.query.cusid
    };
  },
  created() {
    if (!this.accessToken) {
      this.login();
    } else {
      if (this.flag == 'swtichCus' && this.cusId) {
        if (this.cusId != this.userInfo.cusId) {
          let params = {
            cusId: this.cusId
          }
          this.handleSwitchCus(params);
        }
      }
    }
  },
  mounted() {
		document.documentElement.style = '';
    // 主题 light-theme/白  dark-theme/黑
    if ( typeof(localStorage.Theme) == "undefined" ){
      localStorage.setItem('Theme', "light-theme");
      localStorage.setItem('Color', "#000000");
    }
    document.getElementsByTagName("body")[0].className=localStorage.getItem("Theme");
    this.$store.commit('SET_WORKSPACE_RECT',this.$refs.ciicMain);

  },
  computed: {
    ...mapGetters(['isLock','menu', 'accessToken', 'userInfo'])
  },
  props: [],
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    login() {
      const params = this.$route.query;
      this.$store.dispatch('ygjLogon', params).then(res => {
          if (res.data.success) {
            let userType = res.data.data.userType;
            let cusSourceType = res.data.data.cusSourceType;//0 老系统 1新系统
            if ("10620003" != userType) { //当为HR时
              if ("1" == cusSourceType) {

              } else {
                // let hrUrl = hrCommon.HRCLOUD_URL + "/secondMain.action?accessToken=" + base64Encode(encrypt(store.getters.accessToken, ''));
                // window.location.href = hrUrl;
              }
            } else { //雇员时，跳转到雇员端页面
              let empUrl = hrCommon.HRCLOUD_URL + "emp/index.action?accessToken=" + base64Encode(encrypt(store.getters.accessToken, ''));
              window.location.href = empUrl;
            }
          }
          this.setDicts();
        }
      ).catch(error => {})
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 回到顶部
    scrolltop() {
      this.$refs.ciicMainBox.scrollTop = 0
    },
    // 获取字典项
    setDicts() {
      this.getDicts().then((res) => {
        this.dicts = res.data.data;
        this.$store.commit('SET_DICTS', this.dicts)
      });
    },
    //切换客户
    handleSwitchCus(params){
      //切换客户
      var that = this;
      switchCus(params).then(res=>{
        let resData = res.data.data;
        if(res.data.statusCode==200){
          if(res.data.success){
            // this.$message.success(res.data.msg);
            this.$store.commit('SET_ACCESS_TOKEN', resData.access_token);
            this.$store.commit('SET_REFRESH_TOKEN', resData.refresh_token);
            this.$store.commit('SET_CUS_ID', resData.cusId);
            this.$store.commit('SET_USER_INFO',resData);
            this.$store.commit('SET_BRANCH_INFO', {id:resData.branchId});
            this.$store.commit('SET_PMS', resData.pms);
            this.$store.commit('SET_AUTHORIZED_AGENCIES', resData.authorizedAgencies);
            this.$store.commit('SET_CUS_LIST', resData.cusList);
            this.$store.commit('CLEAR_LOCK');
            // setTimeout(function(){
            //   that.$router.go(0);//刷新当前路由
            // },1000);
          }else{
            this.$message.error(res.data.msg);
          }
        }else{
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.index {
  display: flex;
  position: relative;
  background: #fff;
  overflow: hidden;
	height: 100%;
  .left {
    width: 245px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
  }
  .left:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
    z-index: 10;
  }
  .left.is-active:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 0px;
    height: 100%;
    background-color: #7fc4ff;
  }
  .right {
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    flex: 1;
    min-width:calc(100vw - 245px);
    max-width: calc(100vw - 64px);
  }
  .main {
    height: 100%;
    background: #F5F5F5;
    box-sizing: border-box;
    overflow-y: scroll;
    .router {
      padding: 10px;
      background: #fff;
      min-height: 100%;
      height: auto;
      overflow: hidden;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
}
</style>
